export enum Path {
    USER_MANAGERLIST_PATH = "",
}  

export enum Button {
    CLONE = "Clone",
    DELETE = "Delete",
    EDIT = "Edit",
    CANCEL = "Cancel",
    NEW_TEMPLATE = 'New Template',
    ADD_CATEGORY = 'Add Category',
    TAG = 'Add Tag',
    VIEW_SEND_GRID_TEMPLATE = 'View send grid template',
    EXPORT_TO_PDF   = 'Export to Pdf',
    BACKTOTEMPLATE =  'Back to Template List',
    SAVE_TEMPLATE = 'Save Template',
    ADD = 'Add',
    SAVE = 'Save',
    NEW_Snippet  = 'New Snippet',
    UPDATE = 'Update'
}

export enum DisplayName {
  MAILINGLIST = "Mailing List",
  ACTIVE = "Active",
  COMPANY = "Company",
}

export enum PopUpTitles {
  DELETE = "Delete",
  ADD_CATEGORY = "Add Category",
  ADD_TAG = "Add Tag",
  ADD_TEMPLATE = "Add Template",
  NEW_SNIPPET = 'New Snippet' ,
  EDIT_SNIPPET = 'Edit Snippet',
  EDIT_MAILING_LIST = 'Edit Mailing List',
  DISCARD = "Discard",

}
export enum DeletePageType {
  MAILINGLIST = "mailing list",
  MAILINGLISTDETAILS = "record",
  SNIPPET = "Snippet list"

}

export enum TabNames {
  SETTINGS = 'Template-list',
  LIST_MANAGER = 'list-manager',
  SNIPPET_LIST = '/list-manager/snippets-list',
  LIST_MANAGER_INFO = '/list-manager/list-manager-info'
}

export enum ExampleEnum {
  Option1 = 'Text',
  Option2 = 'Number',
  Option3 = 'Date',
}




